import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-output-footer',
  imports: [TranslateModule, MatProgressSpinnerModule],
  templateUrl: './output-footer.component.html',
  styleUrl: './output-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutputFooterComponent implements OnChanges {
  @Input({ required: false }) charactersCount: number;
  @Input({ required: false }) textLength: number;
  @Input({ required: false }) quotePreservation: boolean;
  @Input({ required: false }) hasManualChanges: boolean;
  @Input({ required: false }) showSpinner: boolean;

  text: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasManualChanges || changes.textLength || changes.quotePreservation) {
      this.text = this.getText();
    }
  }

  getText(): string | undefined {
    if (this.hasManualChanges) {
      return undefined;
    }

    if (this.textLength) {
      return this.quotePreservation
        ? 'Rewrite.Optimised for x characters and quote preservation'
        : 'Rewrite.Optimised for x characters';
    }

    if (this.quotePreservation) {
      return 'Rewrite.Optimised for quote preservation';
    }
  }
}
